
  var tests = [];
  module.exports = tests;




//////////////////
// WEBPACK FOOTER
// ./node_modules/browsernizr/lib/tests.js
// module id = APOD
// module chunks = 0